export const MAX_FILES_COUNT = 3;
export const MAX_SIZE_IN_MB = 10;
export const ACCEPTED_FILE_TYPES = '.jpg, .jpeg, .pdf, .png';
export const ACTING_AS = {
  SELLER: 'seller',
  BUYER: 'buyer',
  THIRD: 'third',
};
export const THIRD_PARTY_REGISTRATION = {
  VAT_REGISTERED: 'yes',
  NOT_VAT_REGISTERED: 'no',
};
export const AGREEMENT_TYPE = {
  SELF: 'SelfBilling',
  THIRD: 'ThirdParty',
};
